export default __webpack_public_path__ + "static/media/hewett-hs.fb0306d7.png";